import { css } from 'styled-components';
import token from 'styled-token';
import { iconSizeMixin } from '../iconSizeMixin';
import { marginMixin } from '../marginMixin';

/** @class LoadingMaskMixin */
/** @method */
export var LoadingMaskMixin = function LoadingMaskMixin(props) {
  var _props$display = props.display,
    display = _props$display === void 0 ? 'inline-flex' : _props$display;
  return css(["position:relative;display:", ";", ""], display, marginMixin(props));
};

/** @class LoadingMaskContentMixin */
/** @method */
export var LoadingMaskContentMixin = function LoadingMaskContentMixin(props) {
  if (!props.loading) {
    return '';
  }
  return token('LoadingMask.opacity', function (opacity) {
    return "\n            user-select: none;\n            opacity: " + opacity + ";\n        ";
  })(props);
};

/** @class LoadingMaskSpinnerMixin */
/** @method */
export var LoadingMaskSpinnerMixin = function LoadingMaskSpinnerMixin(props) {
  return css(["position:absolute;top:0;left:0;bottom:0;right:0;display:", ";justify-content:center;align-items:center;", ""], props.loading ? 'flex' : 'none', iconSizeMixin(props));
};